<template>
    <div class="">
        <v-form
           id="nodeform"
           ref="form"
           v-model="valid"
           :lazy-validation="lazy">

            <!-- CARD ACTIONS -->

            <v-toolbar
              flat
              style="border-bottom:2px solid #ddd"              
              >
        
                <v-toolbar-title>TRANSFERPASS
                  <span v-if="process=='add'" class="add">{{ $t('add') }}</span>
                  <span v-else class="edit">{{ $t('edit') }}</span>
                </v-toolbar-title>                  
                  
                    <v-checkbox
                    v-model="node.published"
                    label="Veröffentlicht"
                    dense
                    class="check-published"
                    ></v-checkbox>
                  
                    <v-spacer></v-spacer>                    

                    <v-btn class="mr-4"
                    v-if="node.id"
                    :disabled="!valid"
                    @click="formSubmit"
                    style="display:inline-block"
                    >Aktualisieren</v-btn>

                    <v-btn class="mr-4"
                    v-else
                    :disabled="!valid"
                    @click="formSubmit"
                    style="display:inline-block"
                    >Speichern</v-btn>
                  
                    <v-btn-toggle                        
                      borderless                    
                      dense    
                      class="mr-2"
                      >
                      <v-btn      
                        icon
                        :to="'/'+$home+'content/'+nodetype"
                        >      
                        <v-icon>mdi-table-of-contents</v-icon>
                      </v-btn>

                      <v-btn 
                        icon                                              
                        :to="'/'+$home+'p/field/'+node.id" 
                        target="_blank" 
                        title="Vorschau"
                        >                        
                        <v-icon>
                          mdi-open-in-new
                        </v-icon>
                      </v-btn>

                    </v-btn-toggle>
  
            </v-toolbar>

            <!-- / CARD ACTIONS --->

            <v-row class="nodecontent">

               <v-col cols="7" sm="7" >

                  <v-text-field
                    v-model="node.title"
                    :counter="200"
                    :rules="nameRules"
                    label="Name"
                    background-color="#f7f7f7"
                    required
                    color="#333333"
                    height=auto
                    class="my-5 py-2"
                  ></v-text-field>

                  <v-text-field
                    v-model="node.title_en"
                    :counter="200"
                    :rules="nameRules"
                    label="Name (engl.)"
                    background-color="#f7f7f7"
                    required
                    color="#333333"
                    height=auto
                    class="my-5 py-2"
                  ></v-text-field>

                  <v-text-field
                    v-model="node.alias"
                    :counter="200"                    
                    label="Alias (URL)"
                    background-color="#f7f7f7"                    
                    color="#333333"
                    height=auto
                    class="my-5 py-2"
                  ></v-text-field>

                  <v-select
                      v-model="node.area"
                      :items="areas"
                      item-value="value"
                      label="Forschungsfeld"
                    >
                    <template v-slot:item='{item}'> <span v-html="item.name"></span> </template>
                    <template v-slot:selection='{item}'> <span v-html="item.name"></span> </template>
                  </v-select>

                  <div class="txtwrap">

                    <v-combobox
                      ref="itemsCombobox"
                      v-model="node.tags"
                      :items="tags"
                      label="Schlagwort auswählen oder hinzufügen"
                      :hide-no-data="!search"
                      :search-input.sync="search"                                            
                      multiple
                      chips         
                      @input="clearTags"             
                      @keydown.enter="addTag"
                    >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        close                                            
                        @click:close="removeTag('tags', data.item)"
                      >
                        {{ data.item.name }}
                      </v-chip>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <span class="subheading">No results matching "<strong>{{ search }}</strong>". Press <kbd>enter</kbd> to create a new one</span>
                      </v-list-item>
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-combobox>

                  <!--
                    <v-autocomplete
                        v-model="node.partners"
                        ref="partnerRef"
                        :items="partners"
                        item-value="id"
                        item-text="name"
                        label="Partner"
                        outlined
                        dense
                        small-chips
                        multiple
                          >
                          <template v-slot:selection="data">
                            <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                              @click="data.select"
                              @click:close="remove('partners', data.item)"
                            >
                              {{ data.item.name }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                              <v-list-item-content>
                                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                              </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  -->
                    <v-textarea
                      v-model="node.preview"
                      color="#333333"
                      background-color="#f7f7f7"
                      class="my-2 py-4 px-3"
                      style="border:1px solid #ccc;"
                    >
                      <template v-slot:label>
                        <div>
                          Preview <small>(optional)</small>
                        </div>
                      </template>
                    </v-textarea>

                  </div>
              </v-col>

              <v-col cols="5" sm="5" >

                <v-autocomplete
                  v-model="node.responsible_id"
                  v-on:change="onChangeResponsibility"
                  ref="fieldRef"
                  :items="resps"
                  :rules="[v => !!v || 'Referenz ist erforderlich']"
                  item-value="id"
                  item-text="name"
                  label="verantworlich"
                  class="mt-5 mb-0 py-2"
                  background-color="#f7f7f7"
                  required
                >
                  <template v-slot:item='{item}'> <div v-html='item.name'/> </template>
                  <template v-slot:selection='{item}'> <div v-html='item.name'/></template>
                </v-autocomplete>

                <v-subheader>Vorschaubild</v-subheader>

                <div class="imgwrap">
                  <label>
                    <input type="file" id="file" ref="file" v-on:change="onChangeFileUpload()" />
                  </label>
                  <v-text-field
                    v-model="node.src"
                    type="hidden"
                  ></v-text-field>
                  <div class="previewwrap">
                    <img class="preview" ref="preview" v-if="previewsrc" :src="previewsrc" alt="Preview Image" />
                  </div>
                </div>

                <v-subheader>Bildergalerie</v-subheader>

                <v-file-input
                  v-model="node.images"
                  v-if="node"
                  small-chips
                  accept="image/*"
                  :show-size="1000"
                  style="margin-top:0px !important"
                  counter
                  filled
                  dense
                  placeholder="Wählen Sie Dateien aus"
                  prepend-icon=""
                  prepend-inner-icon="mdi-file-document-outline"
                  multiple
                  :clearable="false"
                  class="pt-0 pb-0"
                  @change="fileAdded()">
                  <template v-slot:selection="{ text, index }">
                      <v-chip small text-color="white" color="#295671" close @click:close="removeFile(index)">
                          {{ text }}
                      </v-chip>
                  </template>
                </v-file-input>

                <div v-if="node.images && node.images.length > 0">
                  <div v-for="(im, index) in node.images" :key="index" style="margin: 0 12px 8px 0;float:left;">
                    <div><img height="120" :src="$config.imagepath + im.name" /></div>
                    <span style="font-size:.72rem;">{{ im.name }}</span>
                  </div>
                </div>

               </v-col>

            </v-row>

            <v-row class="nodecontent">

              <v-col cols="12" sm="12">

                  <v-subheader>Beschreibung</v-subheader>

                  <span class="label">DE</span>
                  <Editor :description="node.description" @update="updateEditor" class="mb-4"></Editor>

                  <span class="label">EN</span>
                  <Editor :description="node.description_en" @update="updateEditorEn" class="mb-4"></Editor>

                  <div class="elementswrap">

                    <v-subheader
                      class="mt-4"
                      >Elemente</v-subheader>
                    
                    <v-row class="elements"
                      >
                      <draggable 
                        v-model="node.elements" 
                        @start="drag=true" 
                        @end="drag=false;checkList(node.elements)" 
                        handle=".dragelemhandle" 
                        style="width:100%;"
                        :move="checkMove"
                        >
                        <v-col cols="12" md="12" v-for="(element, index) in node.elements" :key="index" class="item elements">
                          <div>
                            <div class="dragelemhandle">
                              <v-icon                              
                                class="mx-0 ml-0 pl-0"
                                >
                                mdi-drag-vertical
                              </v-icon>
                            </div>
                            <div :class="{dragelemcontent: true, toggle: element.toggle }">
                              <v-text-field
                                  v-model="element.content_index"
                                  dense
                                  style="visibility: hidden;height:0;overflow: hidden;"
                                ></v-text-field>
                              <div style="text-align:left;width:50%;float:left;display:none;">
                                <v-text-field
                                  v-model="element.cols"                                                                                                    
                                  type="number"
                                  style="width:3rem;display:inline-block"                            
                                  dense
                                  :min="1"
                                  :max="12"       
                                  placeholder="6"                            
                                  aria-required="true"                                                 
                                  ></v-text-field>
                                  <v-text-field                            
                                    style="width:3rem;display:inline-block"
                                    dense
                                    value=" /12"
                                  ></v-text-field>
                              </div>

                              <div style="text-align:left;width:50%;float:left;">
                                <v-select
                                    v-model="element.letterelem"
                                    :items="letterelem"
                                    item-value="id"
                                    label="Absatz Steckbrief"
                                  >
                                  <template v-slot:item='{item}'> <span v-html="item.value"></span> </template>
                                  <template v-slot:selection='{item}'> <span v-html="item.value"></span> </template>
                                </v-select>
                              </div>

                              <div style="text-align:right; width:50%;float:right;">
                                <v-btn
                                  class="mr-4"
                                  @click="toggleElement(index)"
                                  depressed
                                  fab
                                  small
                                  >
                                  <v-icon v-if="element.toggle">mdi-chevron-down</v-icon>
                                  <v-icon v-else>mdi-chevron-up</v-icon>
                                </v-btn>
                                <v-btn 
                                  class="mr-4"    
                                  @click="deleteElement(index)"
                                  depressed
                                  fab
                                  small
                                  >
                                  <v-icon                                                                               
                                  >mdi-close</v-icon>
                                </v-btn>
                              </div>

                              <v-text-field
                                v-model="element.name"                                          
                                label="Titel"
                                background-color="#f7f7f7"
                                required
                                placeholder="Titel"
                                color="#333333"
                                hint="Der hier eingetragene Titel überschreibt den oben ausgewählten"
                                persistent-hint
                                height=auto
                                class="my-0 py-2"
                                style="clear:both"
                              ></v-text-field>

                              <v-row>
                                <v-col cols="6">
                                  <span class="label">Text für Webseite</span>
                                  <Editor :key="index" :elementindex="index" :description="element.content" @update="updateElement"></Editor>
                                </v-col>
                                <v-col cols="6">
                                  <span class="label">Text für PDF-Export</span>
                                  <Editor :elementindex="index" :description="element.contentpdf" @update="updateElementPdf"></Editor>
                                </v-col>
                              </v-row>
                                                  
                            </div>
                          </div>
                        </v-col>  
                      </draggable>
                    </v-row>                                

                    <div class="addelement">
                      <v-btn class="mr-4 mt-4"
                      @click="addElement"
                      >Element hinzufügen</v-btn>
                    </div>

                  </div>

                  <div class="linkswrap">

                    <v-subheader
                    class="mt-4"
                    >Links</v-subheader>
             
                    <v-row class="links"
                      >
                      <draggable v-model="node.links" @start="drag=true" @end="drag=false" handle=".draghandle" style="width:100%;">
                        <v-col cols="12" md="12" v-for="(link, li) in node.links" :key="li" class="item">
                          <div class="draghandle">
                            <v-icon                              
                              class="mx-0 ml-0 pl-0"
                              >
                              mdi-drag-vertical
                            </v-icon>
                          </div>
                          <div class="dragcontent">
                            <div style="text-align:right; width:50%;float:right;">
                              <v-btn 
                                class="mr-4"                          
                                @click="deleteLink(li)"
                                depressed
                                fab
                                small
                                >
                                <v-icon                                                                               
                                >mdi-close</v-icon>
                              </v-btn>
                            </div>
                            <div style="text-align:left;">
                              <v-text-field
                                v-model="link.name"
                                dense
                                placeholder="Name"
                                label="Linkname"
                                aria-required="true"
                                ></v-text-field>
                              <v-text-field
                                v-model="link.url"
                                dense
                                placeholder="URL"
                                label="URL"
                                aria-required="true"                                                 
                                ></v-text-field>                              
                            </div>
                          </div>
                        </v-col>                                                                        
                      </draggable>
                    </v-row>    
                    
                    <div class="addlink">
                      <v-btn class="mr-4 mt-4"
                      @click="addLink"
                      >Link hinzufügen</v-btn>
                    </div>

                  </div>
                  <!--
                    <v-subheader>Veröffentlicht</v-subheader>
                    <v-checkbox
                    v-model="node.published"
                    label="Veröffentlicht"
                    ></v-checkbox>
                  -->
                  <v-text-field
                      v-model="node.id"
                      type="hidden"
                    ></v-text-field>
                  <v-btn class="mr-4"
                    v-if="node.id"
                    :disabled="!valid"
                    @click="formSubmit"
                    >Aktualisieren</v-btn>

                  <v-btn class="mr-4"
                    v-else
                    :disabled="!valid"
                    @click="formSubmit"
                    >
                    Speichern
                    </v-btn>
               </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>

    import Editor from '../tools/Editor';
    import draggable from 'vuedraggable';
    //import VueUploadMultipleImage from 'vue-upload-multiple-image';

    export default {
        name: 'FieldContent',
        data() {
            return {
              search: null,
              areas: [],
              letterelem: [
                {
                  value: 'Leistungsangebote',
                  id: 1
                },
                {
                  value: 'Labore',
                  id: 2
                },
                {
                  value: 'Geräte / Spezialausstattung',
                  id: 3
                },
                {
                  value: 'Software-Lizenzen',
                  id: 4
                },
                {
                  value: 'Patente / Erfindungen',
                  id: 5
                },
                {
                  value: 'Netzwerk-Mitgliedschaften',
                  id: 6
                },
                {
                  value: 'Kooperationen',
                  id: 7
                },
                {
                  value: 'Weiterbildungsangebote',
                  id: 8
                },
                {
                  value: 'Weitere Informationen',
                  id: 9
                }                                                
              ],
              images: [],
              previousFiles: [],
              componentKey: 0,
              published: false,
              previewsrc: null,
              errors: [],
              valid: true,
              file: '',
              resps: [],
              tags: [],
              partners: [],
              nodeRespRef: null,
              nameRules: [
                v => !!v || 'Name erforderlich',
                v => (v && v.length <= 200) || 'Name darf max. 200 Zeichen enthalten',
              ],
              lazy: false
            };
        },
        props: {
            nodetype: {
              type: String
            },
            node: {
              type: Object                
            },
            process: {
              type: String
            }
        },
        components: {
          Editor,
          draggable        
        },
        methods: {
          checkMove (e) {
            // console.log('checkMove');
            console.log(e.related.classList.contains('elements'));
          },
          checkList (list) {
            if(list && list.length > 0) {
              for (var i = 0; i < list.length; i++) {
                list[i].content_index = i;
              }
            }
          },
          clearTags () {
            // let searchTextx = this.search.trim();
            this.node.tags = this.node.tags.filter((x) => typeof x === "object");
          },
          addTag () {  
            let self = this;       
            let searchText = this.search.trim();
            let itemNotFound = !this.$refs.itemsCombobox.filteredItems.length;
            if (itemNotFound && searchText.length) {

              this.inputTag(this.search, function (result) {
                // console.log('result inputTag()');
                // console.log(result);
                let v = {
                  id: result.id, 
                  name: result.name
                };
                self.tags.push(v);
                self.node.tags.push(v);
                // console.log(this.node.tags);
              })
            }
          },
          inputTag (tag, callback) {
            const formData = new FormData();
            formData.set('tag', tag);

            this.axios.post( this.$config.host+"/tag", formData)
            .then(function (response) {
                console.log(response.data);
                if(response.data) {
                  callback(response.data);
                } else {
                  callback(null);
                }
            })
            .catch(function (error) {
              console.log(error);
              callback(null);
            });
          },
          fileAdded () {
            this.previousFiles = this.previousFiles ? this.previousFiles : []
            if (this.previousFiles.length < 1) {
              console.log('no previous files');
              this.previousFiles = this.node.images
            } else {
              console.log('previous files');
              this.node.images.push(...this.previousFiles)
            }
            console.log('fileAdded() - zusammen: ');
            console.log(this.node.images);
            this.previousFiles = this.node.images            
          },
          removeFile (x) {
            console.log('removeFile')
            console.log(x)
            this.node.images.splice(x, 1)
          },
          checkForm (data) {
            console.log(data);
          },
          validate () {
            this.$refs.form.validate()
          },
          reset () {
            this.$refs.form.reset()
          },
          resetValidation () {
            this.$refs.form.resetValidation()
          },
          readURL(input) {
              var self = this;
              if (input.file) {
                  var reader = new FileReader();
                  reader.onload = function (e) {
                      self.previewsrc = e.target.result;
                  }
                  reader.readAsDataURL(input.file);
              } else {
                this.file = self.previewsrc;
              }
          },
          onChangeResponsibility(e){
            // Get new single pano data:
            //let self = this;
            this.nodeRespRef = this.resps.find(resp => resp.id === e);
            this.componentKey += 1;
          },
          handleImageAdded(file, Editor, cursorLocation, resetUploader) {

              var formData = new FormData();
              formData.append("image", file);

              var self = this;

              this.axios.post( this.$config.host+"/image", formData)
                .then(result => {

                  if(result.data == "max") {

                      self.$toasted.error('Datei leider zu groß');

                  } else {

                      let url = self.$config.imagepath + result.data.name;

                      Editor.insertEmbed(cursorLocation, "image", url);
                      console.log(resetUploader);
                      resetUploader();

                  }

                })
                .catch(err => {
                  console.log(err);
                });
          },
          onChangeFileUpload(){
            // console.log("onchangefileupload!");
            this.file = this.$refs.file.files[0];
            //console.log("this.file:");
            //console.log(this.file);
            this.readURL(this);
          },
          formSubmit() {
              //e.preventDefault();

              const config = { 
                headers: { 'Content-Type': 'multipart/form-data' } 
              };
              let imgs = [];

              const formData = new FormData();
              formData.set('title', this.node.title);
              formData.set('title_en', this.node.title_en);
              formData.set('alias', this.node.alias ? this.node.alias : '');
              formData.set('area', this.node.area);
              formData.set('preview', this.node.preview ? this.node.preview : ''); 
              formData.set('description', this.node.description ? this.node.description : '');
              formData.set('description_en', this.node.description_en ? this.node.description_en : '');
              formData.set('responsible_id', this.node.responsible_id);
              formData.set('published', this.node.published);
              formData.set('process', this.node.id ? 'update' : 'generate');
              formData.set('id', this.node.id ? this.node.id : null);
              formData.set('src', this.node.src ? this.node.src : null);
              formData.append('tags', (this.node.tags && this.node.tags.length > 0) ? JSON.stringify(this.node.tags) : null);
              // formData.append('partners', (this.node.partners && this.node.partners.length > 0) ? JSON.stringify(this.node.partners) : null);
              formData.append('file', this.file);              
              formData.append('elements', JSON.stringify(this.node.elements));
              formData.append('links', (this.node.links && this.node.links.length > 0) ? JSON.stringify(this.node.links) : null);
              
              if (this.node.images && this.node.images !== 'undefined') {
                for (let ii = 0; ii < this.node.images.length; ii++) {
                  if(!this.node.images[ii].type) {
                    imgs.push(this.node.images[ii]);
                  } else {
                    imgs.push({
                      name: this.node.images[ii].name,
                      size: this.node.images[ii].size
                    })
                  }
                  formData.append('images[' + ii + ']', this.node.images[ii])
                  
                }
                formData.append('imgs', JSON.stringify(imgs));
              }

              console.log('vor submit: ');
              console.log(formData);

              // Was ist das hier??
              let currentObj = this
              let self = this;
                            
              this.axios.post( this.$config.host+"/field", formData, config)
              .then(function (response) {
                  console.log("response from post field");
                  console.log(response);
                  self.$router.push({path: '/'+self.$home+'content/field'});
                  self.$emit('fieldsaved', null)
              })
              .catch(function (error) {
                  currentObj.output = error;
              });
          },
          updateEditor(content) {
            this.node.description = content;          
          },
          updateEditorEn(content) {
            this.node.description_en = content;          
          },
          updateElement(content,index) {
            // console.log(content);
            // console.log(index);
            this.node.elements[index].content = content;
          },
          updateElementPdf(content,index) {
            // console.log(content);
            // console.log(index);
            this.node.elements[index].contentpdf = content;
          },          
          getResps() {
              this.axios.get( this.$config.host+"/resps" ).then(response => (
                this.resps = response.data
              ));
          },
          getTags() {
              this.axios.get( this.$config.host+"/tags" ).then(response => (
                this.tags = response.data                             
              ));
          },
          getPartners() {
              this.axios.get( this.$config.host+"/partners" ).then(response => (
                this.partners = response.data
              ));
          },
          getAreas() {
            var self = this;
            this.axios.get( this.$config.host+"/areas" ).then(function (response) {                
              response.data.forEach(function (ar) {            
                // console.log(ar)
                self.areas.push({name: ar.name, value: ar.id})
              });                              
            });
          },            
          removeTag (type, item) {
            const index = this.node[type].findIndex(x => x.id === item.id);
            if (index >= 0) this.node[type].splice(index, 1)
          },
          remove (type, item) {
            const index = this.node[type].findIndex(x => x === item.id);
            console.log('index:');            
            console.log(index);
            if (index >= 0) this.node[type].splice(index, 1)
          },
          addElement() {
            this.node.elements.push({
              name: null,
              content: null,
              toggle: false
            })
            this.checkList(this.node.elements);
          },
          addLink() {
            this.node.links.push({
              name: '',
              url: '',
              published: true
            })
          },          
          deleteElement(index) {
            const confirm = window.confirm('Soll dieses Element wirklich gelöscht werden?')
            if (confirm) {
              this.node.elements.splice(index, 1);
            }
          },
          toggleElement(index) {
            console.log('toggleElement: ');
            this.node.elements[index].toggle = !this.node.elements[index].toggle;
          },          
          deleteLink(index) {                        
            this.node.links.splice(index, 1);
          }
        },
        created() {
            this.getResps();
            this.getTags();
            this.getPartners();
            this.getAreas()
        },
        watch: {
            node: function (values) {
                const self = this;
                self.node = values;
                if(self.previewsrc == null) {
                  self.previewsrc =  self.node.pathimg ? self.node.pathimg : null;
                }
                if(self.node.files && self.node.files.length > 0) {
                  self.node.images = []
                  self.node.files.forEach(function (f) {            
                    // console.log(ar)
                    self.node.images.push({name: f.filename, size: 27646})
                    
                  });                              
                  self.previousFiles = self.node.images
                }
                // console.log('node:');
                // console.log(self.node);
            }
        },
    }
</script>

<style>

.v-chip .v-chip__content {
  padding:4px;
}
.v-chip .v-chip__close.v-icon {
  margin-right:0;
}
.v-chip.v-size--default {
  height:28px;
}
.elements .item > div,
.links .item > div {
  padding:10px 14px;
  background-color:#f7f7f7; 
}
.elements .editor {
  margin-bottom:20px;
}
.addelement {
  text-align: right;
  margin-bottom:30px;
}
.form-wrap {
  margin:30px 0;
}
#nodeform .v-subheader {
  padding-left:0;
  padding-right:0;
}
#nodeform .v-label {
  color:#666666;
}
.txtwrap {
  padding: 10px 0;
  margin: 0px 0;
}
.preview {
  display:block;
  max-height:500px;
  max-width:100%;
}
.selecticon {
  height:20px;
  width: auto;
  margin-right:20px;
}
.ck-editor__editable {
  min-height: 300px;
}
.ql-container {
  font-size:1rem;
}
.ql-editor .ql-video {
  width:100%;
  height:450px;
}

.draghandle,
.dragelemhandle {
  float:left;
  width: 2.5rem;
  padding: 8px 8px !important;
}
.draghandle:hover,
.dragelemhandle:hover {
  cursor: pointer;
}
.dragcontent,
.dragelemcontent {
  margin-left: 3.5rem;
}

</style>
